import React from 'react';
import RowWrapper from './RowWrapper';
const TorpedoContentStrip = ({ children , width  })=>{
    return /*#__PURE__*/ React.createElement(RowWrapper, {
        style: {
            width
        }
    }, children);
};
TorpedoContentStrip.displayName = 'TorpedoContentStrip';
export default /*#__PURE__*/ React.memo(TorpedoContentStrip);
